import { render, staticRenderFns } from "./WorkflowFrictionBlock.vue?vue&type=template&id=2a287191&scoped=true"
import script from "./WorkflowFrictionBlock.vue?vue&type=script&lang=js"
export * from "./WorkflowFrictionBlock.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFrictionBlock.vue?vue&type=style&index=0&id=2a287191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a287191",
  null
  
)

export default component.exports